var $9c16a1187d8bc47d$exports = {};
$9c16a1187d8bc47d$exports = {
    "collapse": `Sbalit`,
    "expand": `Rozt\xe1hnout`
};


export {$9c16a1187d8bc47d$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
